"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var THDPhone = function THDPhone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="38" height="38' : size;
  var title = 'Home Depot Phone Icon';
  return "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" aria-label=\"".concat(title, "\" ").concat(iconSize, "  viewBox=\"0 0 38 38\">\n        <path\n        fill=\"#f85907\"\n        d=\"M 35.6875 26.0417 C 33.125 26.0417 30.6458 25.625 28.3333 24.875 C 27.6042 24.625 26.7917 24.8125 26.2292 25.375 L 22.9583 29.4792 C 17.0625 26.6667 11.5417 21.3542 8.60417 15.25 L 12.6667 11.7917 C 13.2292 11.2083 13.3958 10.3958 13.1667 9.66667 C 12.3958 7.35417 12 4.875 12 2.3125 C 12 1.1875 11.0625 0.25 9.9375 0.25 H 2.72917 C 1.60417 0.25 0.25 0.75 0.25 2.3125 C 0.25 21.6667 16.3542 37.75 35.6875 37.75 C 37.1667 37.75 37.75 36.4375 37.75 35.2917 V 28.1042 C 37.75 26.9792 36.8125 26.0417 35.6875 26.0417 Z\"\n    />\n    </svg>\n    ");
};

var _default = THDPhone;
exports["default"] = _default;